require('../../libs/backbone/backbone.ajaxq.adapter.ts');
var GenericView = require('views/generic.view.ts');
var Handlebars = require('handlebars');
var Template = require('text-loader!../templates/users.template.htm');
var UsersTable = require('text-loader!../templates/users_table.template.htm');
var Collection = require('../models/users.paginated.collection.ts');
require('dhtmlxMessage');
var Pagination = require('../views/pagination.view.ts');
var HandlebarsHelpers = require('../../libs/handlebars/handlebars-helpers.ts');
require('../../libs/bootstrap/js/bootstrap-table.js');
var i18n = require("l10n");
var popup = require('popup');

var TheView = GenericView.extend({
    el: $("#container"),
    tagName: 'div',
	template: Handlebars.compile(Template),
	usersTable: Handlebars.compile(UsersTable),
	superInitialize: GenericView.prototype.initialize,
	collection : null,
	isFirstDisplay: true,
	lastSearchedText: "",
	initialize: function () {
		var self = this;
		this.collection = new Collection();
		this.collection.on( 'sync', this.successUsersData, this );
		this.collection.on( 'error', this.errorUsersData, this );
		this.collection.url = '/rest/api/users';
		this.collection.getFirstPage();
	},
	superRender:  GenericView.prototype.render,
	render: function () {
		this.superRender();
		var self = this;
		this.$el.html(this.template());


	},
	events: {
        "click .edit_agent": "editAgent",
        "keyup #search": "search",
        "click #deleteBtn": "delete"
	},
	search: function(event)
	{
		element = $(event.currentTarget);
		var text = element.val().trim();

        if(this.lastSearchedText != text )
        {
			$.ajaxq.abort("DefaultQueue");
			this.lastSearchedText = text;
			this.collection.url = '/rest/api/users?q=' + encodeURIComponent("lastname="+element.val().trim());
			this.collection.getFirstPage();
		}
	},
	successUsersData: function()
	{
		var self = this;
		self.hideActionProgressBar();

		if(this.isFirstDisplay)
		{
			this.isFirstDisplay = false;
			this.render();
            if(this.collection.models.length == 0)
                $('#search-container').hide();
		}
		$('#table-container').html(this.usersTable({ "agents" : this.collection.models, pageInfo : this.collection.info()}));

		this.pagination = new Pagination({ collection : this.collection });
		this.pagination.render();
		$( '#pagination' ).html( this.pagination.$el );

        $("#pageSize li").on("click", function() {

            var pageSize = $(this).text();

            if ( ! $(this).hasClass("active")  )
            {
                $("#pageSize li.active").removeClass("active");
                $(this).addClass("active");
                $("#pageSizeBtn").text(pageSize);
                self.collection.state.pageSize = pageSize;

                self.collection.getFirstPage();
            }

        });

        $("#checkAll").change( function() {
            $("#dataTables").find("input:checkbox").not(this).prop('checked', this.checked);
        });

        $(".check").change( function() {
            if(this.checked && $("#deleteBtn").css('display') == 'none' )
                $("#deleteBtn").show();
            else if ( $("#dataTables").find("input:checked").length == 0  )
                $("#deleteBtn").hide();

        });

		if(this.collection.models.length > 0)
		{
			$('#table-container').show();
			$('#pagination').show();
			$('#empty').hide();

            self.initializeTrs(this.showHideActionButton, "#dataTables");
		}
		else
		{
			$('#table-container').hide();
			$('#pagination').hide();
			$('#empty').show();
		}

	},
	showHideActionButton: function(flag) {
        GenericView.prototype.showHideActionButton(flag, "#deleteBtn", "#dataTables");
    },
	errorUsersData: function(collection, xhr, options)
	{
 		this.onErrorHandler(collection, xhr, options);
	},
    editAgent: function(e) {
        window.location.href = "#User/"+$(e.currentTarget).parent().data("id");
    },
    delete: function() {

        var self = this;

        var ids = "";
        $("#dataTables").find("td input:checked").each( function() {
            ids += ($(this).parent().data("id")) +",";
        });

        url = '/rest/api/users?ids=' + ids;

        var params = {
            "url": url,
            "collection": this.collection,
             "_showProgressBar": self.showActionProgressBar,
             "_hideProgressBar": self.hideActionProgressBar,
             "_deleteBtn": $('#deleteBtn')
        }
        popup.show(i18n.t("pageHeader.confirm_delete"), i18n.t("pageHeader.delete_msg"), "confirm_delete", params);
    }


});

module.exports = TheView;